import { Component, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { ComponentBase } from '../component-base.component';
import { Utils } from '../../utils';
import { CambioPasswordComponent } from '../cambio-password/cambio-password.component';

@Component({
  selector: 'app-impostazioni-utente',
  templateUrl: './impostazioni-utente.component.html',
  styleUrls: ['./impostazioni-utente.component.css']
})
export class ImpostazioniUtenteComponent extends ComponentBase {
  @ViewChild('changepwd') changepwd: CambioPasswordComponent;
  @ViewChild('enable') enable: CambioPasswordComponent;
  @ViewChild('modify') modify: CambioPasswordComponent;
  @ViewChild('disable') disable: CambioPasswordComponent;

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected location: Location
  ) {
    super(route, router, location);
  }


  onInit():void {

  }

  submit() {
  }

  resetCmps() {
    if (this.changepwd) this.changepwd.restartCmp();
    if (this.enable) this.enable.restartCmp();
    if (this.modify) this.modify.restartCmp();
    if (this.disable) this.disable.restartCmp();
  }
/*
  isAbilitazioneAuthDueFattoriEnabled() {
    let utx = Utils.getUserContext();
    return utx && utx.authDueFattoriPossibile && ! utx.authDueFattoriAbilitata; 
  }

  isModificaAuthDueFattoriEnabled() {
    let utx = Utils.getUserContext();
    return utx && utx.authDueFattoriPossibile && utx.authDueFattoriAbilitata; 
  }
*/
}



// WEBPACK FOOTER //
// ./src/app/components/impostazioni-utente/impostazioni-utente.component.ts